export const formatPostcode = (postcode: string): string =>
  postcode.replace(/\s/g, '')

export const isValidPostcode = (postcode: string | undefined): boolean => {
  if (!postcode) return false
  return /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2})$/i.test(formatPostcode(postcode))
}
